// extracted by mini-css-extract-plugin
export default {"relatedChatsDark":"CustomCollapse_relatedChatsDark__Qq+zf"};